import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import UserAvatar from 'view/component/user-avatar'
import { MenuOutlined } from '@ant-design/icons'
import { Grid } from 'antd'
import logo from 'img/PL_PLCP_logo.png'
import MenuPlcp from 'js/view-plcp/component/navbar/component/menu-plcp'
import styles from './styles'

const Navbar = ({ user }) => {
  const { useBreakpoint } = Grid
  const { lg } = useBreakpoint()
  const [mp, updateMp] = useState(false)
  useEffect(() => {
    if (window.location.href.includes('mp')) {
      updateMp(true)
    }
  }, [])
  return (
    <div className='h-100 position-relative'>
      <div className={styles.home_nav_wrapper}>
        <img
          className={styles.collapsed_logo}
          src={logo}
        />
        <div className={styles.nav_menu}>
          <MenuOutlined
            className={`${lg ? 'd-none' : 'd-flex'} ${styles.burger_icon}`}
          />
          <MenuPlcp menuDisplay={lg ? '' : styles.menu_dropdown} mp={mp} />
        </div>
        <div>
          <div className={classnames(styles.nav_content_right)}>
            {!mp &&
            <UserAvatar
              inPlcp={true}
              user={user}
            />}
          </div>
        </div>
      </div>
    </div>
  )
}

Navbar.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

export default connect(mapStateToProps)(Navbar)
